import { useSliderLayout } from '../hooks/useSliderLayout';

type SlideChildrenContainerProps = { children: React.ReactNode };

const SlideChildrenContainer = ({ children }: SlideChildrenContainerProps) => {
	const { blockClass } = useSliderLayout();

	return (
		<div
			className={`slideChildrenContainer slideChildrenContainer--${blockClass} vtex-slider-layout-0-x-slideChildrenContainer vtex-slider-layout-0-x-slideChildrenContainer--${blockClass} flex justify-center items-center w-100
      `}
		>
			{children}
		</div>
	);
};

export default SlideChildrenContainer;
